import { FaqItem } from "@/components/screen/global-components/faq/FaqStack";

export const faqItems: FaqItem[] = [
  {
    id: "item-1",
    title: "How does the translation process work?",
    description: [
      "Our proprietary three-step, four-human workflow ensures the highest accuracy with fast turnaround times—even for complex, high-volume projects.",
      "<strong>Order and initiation</strong> — Place your order online, choose your language pairs, select standard or certified translation, and add any extras like notarization, expedited delivery, or hard copy shipping. Standard orders begin immediately upon payment—delivered within 24 hours. For high-volume or specialized business needs, request a quote and we will respond within 24 hours.",
      "<strong>Multi-human translation and proofing</strong> — A specialized translator completes your project with built-in quality assurance checking grammar, syntax, and spelling. A second linguist proofreads and edits for accuracy. For enterprise clients, a third reviewer ensures compliance with project requirements.",
      "<strong>Delivery and revisions</strong> — We deliver your completed digital translation for your review. We offer unlimited free revisions until you are 100% satisfied.",
    ],
    linkText: "Learn more",
    link: "#",
  },
  {
    id: "item-2",
    title: "Can I cancel my order or get a refund if I’m not satisfied?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-3",
    title: "Can I get a refund if I’m not satisfied with the translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-4",
    title: "How long does it take to get a translation?",
    description: [
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
      "Our enterprise services accommodate more specialized and custom translations. If you need expertise in a specific industry or use case, have specific formatting needs, have a high-volume or ongoing request, or other more complex or unique requirements, our enterprise option is the best route forward. You’d fill out our form with your details, and someone on our team will be in touch within 24-hours to confirm your personalized options and quote.",
    ],
    linkText: "Learn more",
    link: "#",
  },
  {
    id: "item-5",
    title: "What file formats do you accept?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-6",
    title: "What languages do you support?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-7",
    title: "Can I request translations in multiple languages?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-8",
    title: "Do you offer any discounts?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-9",
    title: "Do you offer invoicing for businesses?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-10",
    title: "What payment methods do you accept?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-11",
    title: "Who will translate my documents?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
];
